import { enfileirar } from '@/lib/offline';
import { toast } from '@/lib/stores/toastStore';

/**
 * Envolve uma criação para que ela sobreviva à falta de rede.
 *
 * Tenta enviar primeiro, sempre. Só cai na fila quando a falha é de conexão --
 * `err.response` ausente no axios, que é o que distingue "não cheguei ao
 * servidor" de "o servidor respondeu recusando". Enfileirar um 400 faria o
 * aparelho reenviar para sempre um pedido que nunca vai ser aceito.
 *
 * A promessa devolvida não resolve com o registro criado no caso enfileirado,
 * porque ele não existe ainda. Quem chama recebe `null` e a tela precisa
 * tratar isso -- é mais honesto que devolver um objeto falso com id inventado,
 * que apareceria na lista e sumiria no próximo carregamento.
 */
export function criarComFilaOffline<T>(
  executar: () => Promise<T>,
  fila: { metodo: 'POST' | 'PUT'; url: string; corpo: unknown; rotulo: string },
): Promise<T | null> {
  return executar().catch(async (err: any) => {
    const semResposta = !err?.response;
    if (!semResposta) throw err;

    await enfileirar(fila);
    toast(
      `Sem conexão. "${fila.rotulo}" foi guardado no aparelho e será enviado quando a rede voltar.`,
    );
    return null;
  });
}
